import { LinkedGroup } from '@/domain/models/LinkItem';
import { errorHandler } from '@/lib/ErrorHandler';
import { getClient } from '@/lib/restClient';
import { LinkedGroupService } from '@/services/LinkedGroup';

export const useLinkedGroup = async (): Promise<{ groups: LinkedGroup[] }> => {
  const linkedGroupService = new LinkedGroupService(getClient());

  return linkedGroupService
    .fetch()
    .catch((error: Error) => errorHandler({ error }));
};
